import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

interface HeaderProps {
  onOpenKitForm?: () => void;
}

export default function Header({ onOpenKitForm }: HeaderProps) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleCheckEligibility = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (onOpenKitForm) {
      onOpenKitForm();
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0A1628]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-20">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link 
            to="/"
            className="flex items-center gap-3 cursor-pointer group"
          >
            <img 
              src="https://public.readdy.ai/ai/img_res/b2886c74-45c3-4d22-86ef-90787632f795.png" 
              alt="FallbackFunds Logo" 
              className="h-10 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <span className="text-[#D4AF37] text-2xl font-bold hidden sm:block">
              FallbackFunds
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            <a 
              href="#how-it-works" 
              className="text-[#F5F5F0] hover:text-[#D4AF37] transition-colors text-base font-medium cursor-pointer"
            >
              How It Works
            </a>
            <a 
              href="#who-we-help" 
              className="text-[#F5F5F0] hover:text-[#D4AF37] transition-colors text-base font-medium cursor-pointer"
            >
              Who We Help
            </a>
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <a 
              href="#"
              onClick={handleCheckEligibility}
              className="inline-block border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-semibold px-6 py-2.5 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Check Eligibility
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-[#F5F5F0] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-[#0A1628] border-t border-[#D4AF37]/20 py-6">
            <nav className="flex flex-col gap-4">
              <a 
                href="#how-it-works" 
                className="text-[#F5F5F0] hover:text-[#D4AF37] transition-colors text-base font-medium cursor-pointer py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                How It Works
              </a>
              <a 
                href="#who-we-help" 
                className="text-[#F5F5F0] hover:text-[#D4AF37] transition-colors text-base font-medium cursor-pointer py-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Who We Help
              </a>
              <a 
                href="#"
                onClick={handleCheckEligibility}
                className="inline-block border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-semibold px-6 py-2.5 rounded-full transition-all duration-300 text-center whitespace-nowrap cursor-pointer mt-2"
              >
                Check Eligibility
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
